export const SAVE_REQUEST = 'SETTINGS/SAVE/REQUEST';
export const SAVE_FAILURE = 'SETTINGS/SAVE/FAILURE';
export const SAVE_SUCCESS = 'SETTINGS/SAVE/SUCCESS';
export const PUBLISH_REQUEST = 'DVR/PUBLISH/REQUEST';
export const PUBLISH_SUCCESS = 'DVR/PUBLISH/SUCCESS';
export const PUBLISH_FAILURE = 'DVR/PUBLISH/FAILURE';
export const SAVE_DBE_REQUEST = 'DBE/SAVE/REQUEST';
export const SAVE_DBE_FAILURE = 'DBE/SAVE/FAILURE';
export const SAVE_DBE_SUCCESS = 'DBE/SAVE/SUCCESS';